﻿/* global FS */
import { addScriptAsync } from "./addScript";

const nonce = document.currentScript?.nonce;

function init(context, selector = ".v3-jsrecapctha") {
	let grecaptcha = window.grecaptcha;
	let scriptLoadTask;
	let siteKey;

	context.querySelectorAll(selector).forEach(e => {
		const form = e.form;
		const name = e.name;
		siteKey ||= e.dataset.sitekey;
		if (!siteKey) {
			console.error("Please include reCAPTCHA API script with render=<site key> parameter first!");
			return;
		}

		function submitRecaptchaEnabledForm(form) {
			if (!form.checkValidity || form.checkValidity()) {
				var grt = form.elements[name];
				if (grt) {
					grecaptcha.ready(function () {
						grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
							grt.value = token;
							FS.Form.doSubmit(form, false);
						});
					});
					return false;
				}
			}
			FS.Form.doSubmit(form, false);
		}

		if (!grecaptcha) {
			scriptLoadTask ||= addScriptAsync({ src: "https://www.google.com/recaptcha/api.js?render=" + siteKey, nonce });
			scriptLoadTask.then(() => {
				grecaptcha = window.grecaptcha;
				form.doSubmitHook = submitRecaptchaEnabledForm;
			});
		} else {
			form.doSubmitHook = submitRecaptchaEnabledForm;
		}
	});
}

export { init };